import { User } from "./User"

export interface UserStateModel {
    user: User | null;
    addUser : (user: User) => void;
    removeUser  : (user: User) => void;
    updateUser : (user: User) => void;
  }

  export const initialUserState: UserStateModel = {
    user: null,
    addUser : () => undefined,
    removeUser : () => undefined,
    updateUser : () => undefined
  };